import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { HelpText } from '../model/HelpText';

@Injectable({
  providedIn: 'root'
})
export class HelpTextService {

  constructor(private http: HttpClient,
              private configService: ConfigService
  ) { }

  public getHelpText(code:string ): Observable<HelpText> {
      return this.http.get<HelpText>(
        this.configService.PortalWebApiUrl + 'helpText/' + code)
  }

  public storeHelpText(data: HelpText): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'helpText', data);
  }
}